<template>
  <div ref="root" class="bank-select" :class="{ 'bank-select--open': open }">
    <button
      :id="id"
      type="button"
      class="form-control bank-select__trigger"
      :class="{ 'bank-select__trigger--placeholder': !value }"
      @click="toggle"
    >
      <span class="bank-select__label">{{ value || placeholder }}</span>
      <i class="bi bi-chevron-down bank-select__caret"></i>
    </button>

    <div v-if="open" class="bank-select__panel">
      <div class="bank-select__search">
        <i class="bi bi-search"></i>
        <input
          ref="search"
          v-model="query"
          type="text"
          class="bank-select__search-input"
          placeholder="Buscar banco..."
          @keydown.esc.prevent="close"
        >
      </div>

      <ul class="bank-select__list" role="listbox">
        <li
          v-for="banco in bancosFiltrados"
          :key="banco.codigo"
          class="bank-select__option"
          :class="{ 'bank-select__option--active': banco.denominacion === value }"
          role="option"
          @click="select(banco.denominacion)"
        >
          {{ banco.denominacion }}
        </li>
        <li v-if="!bancosFiltrados.length" class="bank-select__empty">
          Sin resultados
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const BANCOS = [
  { codigo: "00007", denominacion: "BANCO GALICIA" },
  { codigo: "00011", denominacion: "BANCO NACION ARG" },
  { codigo: "00014", denominacion: "BANCO PROVINCIA BS AS" },
  { codigo: "00015", denominacion: "I.C.B.C." },
  { codigo: "00016", denominacion: "CITIBANK" },
  { codigo: "00017", denominacion: "BANCO BBVA" },
  { codigo: "00020", denominacion: "BANCO PROV CORDOBA" },
  { codigo: "00027", denominacion: "BANCO SUPERVIELLE" },
  { codigo: "00029", denominacion: "BANCO CIUDAD BUENOS AIRES" },
  { codigo: "00034", denominacion: "BANCO PATAGONIA" },
  { codigo: "00044", denominacion: "BANCO HIPOTECARIO" },
  { codigo: "00045", denominacion: "BANCO DE SAN JUAN" },
  { codigo: "00065", denominacion: "BANCO MUNICIPAL DE ROSARIO" },
  { codigo: "00072", denominacion: "BANCO SANTANDER RIO" },
  { codigo: "00083", denominacion: "BANCO DEL CHUBUT" },
  { codigo: "00086", denominacion: "BANCO DE SANTA CRUZ" },
  { codigo: "00093", denominacion: "BANCO LA PAMPA SOCIEDAD" },
  { codigo: "00094", denominacion: "BANCO DE CORRIENTES" },
  { codigo: "00097", denominacion: "BANCO PROVINCIA NEUQUEN" },
  { codigo: "00143", denominacion: "BRUBANK" },
  { codigo: "00147", denominacion: "BANCO INTERFINANZAS" },
  { codigo: "00150", denominacion: "HSBC BANK ARGENTINA" },
  { codigo: "00158", denominacion: "OPEN BANK ARGENTINA" },
  { codigo: "00165", denominacion: "JPMORGAN CHASE BANK" },
  { codigo: "00191", denominacion: "BANCO CREDICOOP COOPERATIVO" },
  { codigo: "00198", denominacion: "BANCO DE VALORES" },
  { codigo: "00247", denominacion: "BANCO ROELA" },
  { codigo: "00254", denominacion: "BANCO MARIVA" },
  { codigo: "00259", denominacion: "BANCO ITAU" },
  { codigo: "00266", denominacion: "BNP PARIBAS" },
  { codigo: "00268", denominacion: "BANCO PROVINCIA TIERRA DEL FUEGO" },
  { codigo: "00269", denominacion: "BANCO REPUBLICA DEL URUGUAY" },
  { codigo: "00277", denominacion: "BANCO SAENZ" },
  { codigo: "00281", denominacion: "BANCO MERIDIAN" },
  { codigo: "00285", denominacion: "BANCO MACRO" },
  { codigo: "00299", denominacion: "BANCO COMAFI" },
  { codigo: "00300", denominacion: "BANCO INVERSION Y COMERCIO EXTERIOR" },
  { codigo: "00301", denominacion: "BANCO PIANO" },
  { codigo: "00305", denominacion: "BANCO JULIO SOCIEDAD ANONIMA" },
  { codigo: "00309", denominacion: "BANCO RIOJA" },
  { codigo: "00310", denominacion: "BANCO DEL SOL" },
  { codigo: "00311", denominacion: "NUEVO BANCO DEL CHACO" },
  { codigo: "00312", denominacion: "BANCO VOII" },
  { codigo: "00315", denominacion: "BANCO DE FORMOSA" },
  { codigo: "00319", denominacion: "BANCO CMF" },
  { codigo: "00321", denominacion: "BANCO DE SANTIAGO DEL ESTERO" },
  { codigo: "00322", denominacion: "BANCO INDUSTRIAL" },
  { codigo: "00330", denominacion: "NUEVO BANCO SANTA FE" },
  { codigo: "00331", denominacion: "BANCO CETELEM ARGENTINA" },
  { codigo: "00332", denominacion: "BANCO DE SERVICIOS FINANCIEROS" },
  { codigo: "00336", denominacion: "BANCO BRADESCO ARGENTINA" },
  { codigo: "00338", denominacion: "BANCO DE SERVICIOS Y TRANSACCIONES" },
  { codigo: "00339", denominacion: "RCI BANQUE" },
  { codigo: "00340", denominacion: "BACS BANCO DE CREDITO Y SECURITIZACION" },
  { codigo: "00341", denominacion: "BANCO MASVENTAS" },
  { codigo: "00384", denominacion: "WILOBANK" },
  { codigo: "00386", denominacion: "NUEVO BANCO DE ENTRE RIOS" },
  { codigo: "00389", denominacion: "BANCO COLUMBIA" },
  { codigo: "00426", denominacion: "BANCO BICA" },
  { codigo: "00431", denominacion: "BANCO COINAG" },
  { codigo: "00432", denominacion: "BANCO DE COMERCIO" },
  { codigo: "00435", denominacion: "BANCO SUCREDITO REGIONAL" },
  { codigo: "00448", denominacion: "BANCO DINO" },
  { codigo: "00515", denominacion: "BANK OF CHINA LIMITED SUCURSAL BUENOS AIRES" },
  { codigo: "44059", denominacion: "FORD CREDIT COMPAÑIA FINANCIERA" },
  { codigo: "44077", denominacion: "COMPAÑIA FINANCIERA ARGENTINA" },
  { codigo: "44088", denominacion: "VOLKSWAGEN FINANCIAL SERVICES" },
  { codigo: "44090", denominacion: "IUDU COMPAÑÍA FINANCIERA" },
  { codigo: "44092", denominacion: "FCA COMPAÑIA FINANCIERA" },
  { codigo: "44093", denominacion: "GPAT COMPAÑIA FINANCIERA" },
  { codigo: "44094", denominacion: "MERCEDES-BENZ COMPAÑÍA FINANCIERA" },
  { codigo: "44095", denominacion: "ROMBO COMPAÑÍA FINANCIERA" },
  { codigo: "44096", denominacion: "JOHN DEERE CREDIT COMPAÑÍA FINANCIERA" },
  { codigo: "44098", denominacion: "PSA FINANCE ARGENTINA COMPAÑÍA FINANCIERA" },
  { codigo: "44099", denominacion: "TOYOTA COMPAÑÍA FINANCIERA DE ARGENTINA" },
  { codigo: "45030", denominacion: "NARANJA DIGITAL COMPAÑÍA FINANCIERA" },
  { codigo: "45056", denominacion: "MONTEMAR COMPAÑIA FINANCIERA" },
  { codigo: "45072", denominacion: "TRANSATLANTICA COMPAÑIA FINANCIERA" },
  { codigo: "65203", denominacion: "CREDITO REGIONAL COMPAÑIA FINANCIERA" },
];

const BANCOS_ORDENADOS = [...BANCOS].sort((a, b) =>
  a.denominacion.localeCompare(b.denominacion),
);

const normalizar = (s) =>
  s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export default {
  props: {
    value: { type: String, default: '' },
    id: { type: String, default: 'bancos-input' },
    placeholder: { type: String, default: 'Seleccionar banco' },
  },
  data() {
    return {
      open: false,
      query: '',
    };
  },
  computed: {
    bancosFiltrados() {
      const q = normalizar(this.query.trim());
      if (!q) return BANCOS_ORDENADOS;
      return BANCOS_ORDENADOS.filter((b) =>
        normalizar(b.denominacion).includes(q),
      );
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onClickOutside);
  },
  methods: {
    toggle() {
      if (this.open) {
        this.close();
      } else {
        this.openPanel();
      }
    },
    openPanel() {
      this.open = true;
      this.query = '';
      this.$nextTick(() => {
        if (this.$refs.search) this.$refs.search.focus();
      });
    },
    close() {
      this.open = false;
    },
    select(denominacion) {
      this.$emit('input', denominacion);
      this.close();
    },
    onClickOutside(event) {
      if (this.open && this.$refs.root && !this.$refs.root.contains(event.target)) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.bank-select {
  position: relative;
}

.bank-select__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: var(--surface);
}

.bank-select__trigger--placeholder .bank-select__label {
  color: var(--text-muted);
}

.bank-select__label {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bank-select__caret {
  flex: 0 0 auto;
  font-size: 12px;
  color: var(--text-muted);
  transition: transform 0.15s ease;
}

.bank-select--open .bank-select__caret {
  transform: rotate(180deg);
}

.bank-select__panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
  overflow: hidden;
}

.bank-select__search {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-soft);
  background: var(--surface-subtle);
}

.bank-select__search i {
  position: absolute;
  right: 22px;
  color: var(--text-muted);
  font-size: 13px;
  pointer-events: none;
}

.bank-select__search-input {
  width: 100%;
  padding: 6px 30px 6px 10px;
  font-size: 13px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface);
  outline: none;
}

.bank-select__search-input:focus {
  border-color: #ff6b00;
  box-shadow: 0 0 0 3px rgba(255, 107, 0, 0.15);
}

.bank-select__list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  max-height: 260px;
  overflow-y: auto;
}

.bank-select__option {
  padding: 8px 14px;
  font-size: 13px;
  color: var(--text);
  cursor: pointer;
  transition: background-color 0.1s ease;
}

.bank-select__option:hover {
  background: var(--surface-hover);
}

.bank-select__option--active {
  background: rgba(255, 107, 0, 0.08);
  color: #ff6b00;
  font-weight: 500;
}

.bank-select__empty {
  padding: 14px;
  font-size: 13px;
  color: var(--text-muted);
  text-align: center;
}
</style>
